import { addDays, format } from "date-fns"

import type { ReportConfig } from "./reportTypes"

export function pacificToday() {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Los_Angeles",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date())
}

/** Picker Dates carry calendar fields, not instants in the reporting timezone. */
export function reportRange(config: ReportConfig, defaultEnd?: string) {
  const end = new Date(
    `${config.period_end || defaultEnd || pacificToday()}T12:00:00`,
  )
  if (!config.period_end && !defaultEnd) {
    end.setDate(end.getDate() - ((end.getDay() + 6) % 7))
  }
  return {
    start:
      config.period_start === ""
        ? null
        : config.period_start
          ? new Date(`${config.period_start}T12:00:00`)
          : addDays(end, -7),
    end: config.period_end === "" ? null : addDays(end, -1),
  }
}

export function reportRangeChange(start: Date | null, end: Date | null) {
  return {
    period_start: start ? format(start, "yyyy-MM-dd") : "",
    period_end: end ? format(addDays(end, 1), "yyyy-MM-dd") : "",
  }
}

export function reportRangeError(config: ReportConfig): string | null {
  if (config.period_start === undefined) {
    return null
  }
  if (!config.period_start || !config.period_end) {
    return "Choose both a start and end date."
  }
  if (config.period_start >= config.period_end) {
    return "End date must be on or after start date."
  }
  if (
    config.period_end >
    format(addDays(new Date(`${pacificToday()}T12:00:00`), 1), "yyyy-MM-dd")
  ) {
    return "Choose a range ending today or earlier."
  }
  return null
}
